<template>
    <div class="calculator-number-input">
        <label>{{ label }}</label>
        <div class="input-number-wrapper" :data-isHover="isHover" :data-isActive="isaActive||inputVal">
            <input type="number" :placeholder="this.$getContent('input_number_placeholder' , 'Enter Value')" v-on:keydown="removeMinus" v-model="inputVal" @focus="isaActive=1" @blur="isaActive=0">
            <button class="change-wrapper increment" @click="incrementVal(1)"><div class="changeValue"></div></button>
            <button class="change-wrapper decrement" @click="incrementVal(-1)"><div class="changeValue"></div></button>
        </div>
    </div>
</template>

<script>
	export default {
		name: "calculatorNumberInput" ,
		data () {
			return {
				inputVal : '',
				isaActive : 0 ,
				isHover:0
			}
		} ,
		methods : {
			removeMinus(e){
                if(e.keyCode == 189){
                	e.preventDefault() ;
                }
            } ,
			incrementVal(val){
				let inputVal = parseInt(this.inputVal) ;
		        inputVal = Number.isInteger(inputVal) ? inputVal : 0 ; 
				this.inputVal = inputVal + parseInt(val) ;
				this.inputDetails[this.inputName] = this.inputVal ;
			}
		},
        watch:{
	        inputVal(newval , oldval){
	        	if(newval < 0){
	        		this.inputVal = 0 ;
                }
		        if(this.inputName == 'tradeSize' && newval > 100){
			        this.inputVal = oldval ;
		        }
		        this.inputDetails[this.inputName] = this.inputVal ;
            }
        } ,
		props : ['label' , "inputDetails" , 'inputName']
	}
</script>

<style lang="scss">
.calculator-number-input{
    .input-number-wrapper{
        display: inline-block;
        padding-left: 50px;
        padding-right: 50px;
        width: 100%;
        position: relative;
        .change-wrapper{
            position: relative;
            &:before{
                content: "";
                background: #fff;
                width: 16px;
                height: 2px;
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
            &.increment:after{
                content: '';
                background: #fff;
                width: 16px;
                height: 2px;
                position: absolute;
                top: 47%;
                left: 30%;
                transform: rotate(-90deg);
            }
        }
        .change-wrapper{
            display: block;
            width: 40px;
            height: 40px;
            margin: 0;
            padding: 0;
            line-height: 34px;
            background-color: #454545;
            border-radius: 6px;
            border: none;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: #d8d8d8;
            text-align: center;
            font-size: 35px;
            font-weight: 600;
            box-shadow: none;
        }
        body:not(.rtl) &{
            .increment{
                right: 5px;
            }
            .decrement{
                left: 5px;
            }
        }
        .rtl &{
            .increment{
                left: 5px;
            }
            .decrement{
                right: 5px;
            }
        }

        input{
            height: 50px;
            width: 100%;
            text-align: center;
            border: none;
            background-color: inherit ;
            font-size: 20px;
            font-weight: 300;
            &:focus{
                outline: 0;
            }
        }

        &[data-isActive="0"]{
            input{
                color: #999999 ;
            }
            .change-wrapper{
                &:before,&:after{
                    background:#999999 ;
                }
            }
        }

        &:hover{
            .change-wrapper{
                &:before,&:after{
                    background:#ffc900 ;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/calculatorInputs/calculatorNumberInput.vue